/**
 * src/components/shared/providers.tsx
 *
 * Client-side provider tree — next-themes + HeroUI I18nProvider (React Aria locale).
 * NextIntlClientProvider Server Component'te kurulur (cunku messages prop'u serializable
 * RSC payload'unda akar).
 *
 * Bu component 'use client' boundary'sidir; ama icerigi (children) yine Server
 * Component agacini barindirir — providers shadow degil, agacin disindadirlar.
 */

'use client'

import { I18nProvider, Toast } from '@heroui/react'
import { ThemeProvider } from 'next-themes'
import type { ReactNode } from 'react'

interface ProvidersProps {
  /** BCP 47 locale tag ('tr-TR', 'en-US'). React Aria icin. */
  locale: string
  children: ReactNode
}

/**
 * Public ve CMS route'larinin paylastigi provider tree.
 *
 * - next-themes: dark/light/system, `<html class="dark|light">` toggle eder
 * - I18nProvider: React Aria component'lerine locale akitir (date pickers,
 *   number formatters, vb.) — HeroUI v3 docs/frameworks.mdx onerisi
 */
export function Providers({ locale, children }: ProvidersProps) {
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableSystem disableTransitionOnChange>
      <I18nProvider locale={locale}>
        {/* Toast.Provider — `toast()`, `toast.success()`, `toast.danger()` çağrıları
            herhangi bir component'ten yapılabilir. Default placement bottom-end. */}
        <Toast.Provider />
        {children}
      </I18nProvider>
    </ThemeProvider>
  )
}
